import { render, staticRenderFns } from "./Vipstu.vue?vue&type=template&id=707a1bde&scoped=true"
import script from "./Vipstu.vue?vue&type=script&lang=js"
export * from "./Vipstu.vue?vue&type=script&lang=js"
import style0 from "./Vipstu.vue?vue&type=style&index=0&id=707a1bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a1bde",
  null
  
)

export default component.exports